import type { EntryStatus } from '../types'
import { STATUS_LABELS } from '../types'

export function StatusBadge({ status }: { status: EntryStatus }) {
  const cls =
    status === 'verified'     ? 'badge-verified'     :
    status === 'needs_review' ? 'badge-needs-review' :
    'badge-unverified'

  return <span className={cls}>{STATUS_LABELS[status]}</span>
}

export function POSBadge({ pos }: { pos: string }) {
  if (!pos) return null
  return <span className="badge-pos">{pos}</span>
}
